import api from '../api';


export const create = async (projectName) => {
  const res = await api.post('/projects', { name: projectName });
  return res.data;
};

export const getAll = async () => {
  const res = await api.get(`/projects`, { params: { includeDeleted: true } });
  return res.data;
}

export const updateProject = async (id, payload) => {
  const res = await api.put(`/projects/${id}`, payload);
  return res.data;
};
export const restoreProject = async (id) => {
  const res = await api.put(`/projects/${id}/restore`);
  return res.data;
};

export const deleteProject = async (id) => {
  const res = await api.delete(`/projects/${id}`);
  return res.data;
};

export const getRegions = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/regions`);
  return res.data;
};

export const getActivities = async (projectId, { page = 0, size = 10, search = '', startDate, endDate }) => {
  const qs = new URLSearchParams({
    page: String(page),
    size: String(size),
  });
  if (search) qs.set('search', search);
  if (startDate) qs.set('startDate', startDate);
  if (endDate) qs.set('endDate', endDate);

  const { data } = await api.get(`/projects/${projectId}/activities?${qs.toString()}`);

  // normalize
  const payload = data?.data || data;
  return {
    data: payload?.activities || [],
    pageCount: payload?.totalPages || 0,
    totalItems: payload?.totalItems || 0
  };
};

export const getProvinces = async () => {
  const res = await api.get('/provinces');
  return res.data;
};

